import React from 'react';
import { Flex, Box, Small } from 'rebass';
import Tags from '../app/components/tags';
import FacebookPageLink from '../app/components/facebook_page_link';
import FacebookLikeButton from '../app/components/facebook_like_button';
import GithubButton from '../app/components/github_button';
import Email from '../app/components/email';
import { site, contact, tags } from '../app/data';
import Branding from '../Branding';

export default () => (
  <Box
    mt={3}
    pt={2}
    mx={3}
    px={2}
  >
    <Branding />
    <Flex column>
      <Box
        mt={3}
        mb={4}
        mr={-1}
      >
        <Tags tags={tags} />
      </Box>
      <Flex style={{ height: '33px' }}>
        <Box
          pr={2}
          mb={2}
        >
          <GithubButton />
        </Box>
        <Box>
          <FacebookLikeButton
            appId={site.meta.facebook.appId}
            url={contact.facebookPage.url}
          />
        </Box>
      </Flex>
      <Box mb={2}>
        <Small>
          <Email address={contact.email} />
        </Small>
      </Box>
      <Box mb={4}>
        <FacebookPageLink url={contact.facebookPage.url} />
      </Box>
    </Flex>
  </Box>
);



// WEBPACK FOOTER //
// ./src/Sidebar/index.js